/**
 * One-time copy from a legacy key to the Wild Network canonical key (localStorage).
 */
export function migrateLocalStorageKey(newKey: string, legacyKey: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    if (localStorage.getItem(newKey) != null) return;
    const prev = localStorage.getItem(legacyKey);
    if (prev != null) {
      localStorage.setItem(newKey, prev);
      localStorage.removeItem(legacyKey);
    }
  } catch {
    // ignore quota / private mode
  }
}

/**
 * One-time copy from a legacy key to the Wild Network canonical key (sessionStorage).
 */
export function migrateSessionStorageKey(newKey: string, legacyKey: string): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    if (sessionStorage.getItem(newKey) != null) return;
    const prev = sessionStorage.getItem(legacyKey);
    if (prev != null) {
      sessionStorage.setItem(newKey, prev);
      sessionStorage.removeItem(legacyKey);
    }
  } catch {
    // ignore
  }
}
